import {Tooltip} from "react-tippy";
import Cleave from "cleave.js/dist/cleave-react-node";
import {ThemeProvider} from "@material-ui/styles";
import {KeyboardDatePicker, KeyboardTimePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/esm/locale/es";
import Flex from "../Flex";
import ReactSelectFlag from "../../Helpers/selectFlag";
import React from "react";
import {Campo} from "./styles";
import {createMuiTheme} from "@material-ui/core";
import {blue} from "@material-ui/core/colors";
import { StopOutline } from '@ant-design/icons';
import AntdIcon from '@ant-design/icons-react';

const materialTheme = createMuiTheme({
    palette: {
        primary: blue
    },
    overrides: {
        MuiFormControl: {
            root: {
                width: "100%",
            }
        },
        MuiInputBase: {
            adornedEnd: {
                background: "white",
            },
            root: {
                boxShadow: "rgba(0, 0, 0, 0.2) 0px 1px 3px",
                borderRadius: 4,
            }

        },
        MuiOutlinedInput: {
            root: {
                borderColor: "#ffffff !important",
                borderWidth: "0 !important"
            },
            notchedOutline: {
                borderColor: "#ffffff !important",
                borderWidth: "0 !important"
            }
        },
        MuiIconButton: {
            root: {
                padding: 0
            }

        }
    },
});

const styleErrorIcon = { 
    color: '#E1251B',
    "transform": "rotate(90deg)",
    right: "20px",
    bottom: "20px",
    position: "absolute",
    height: "20px",
    width: "20px"
};

const maxLength = (configCampos, configCampo) => {

    let MaxLength = configCampos && configCampos.length > 0 ? configCampos.filter((conf) => {
        return conf.value === configCampo;
    }) : [];
    return MaxLength.length > 0 ? parseInt(MaxLength[0]["longitud"]) : 500;
};

const checkedCheckbox = (value, option) => {
    let checked = false;
    if (value !== "") {
        value.map((v) => {
            if (v === option) checked = true
        })
    }
    return checked
};


const MyCampo = (props) => {

    let {
        label,
        className,
        error,
        id,
        value,
        onchange,
        placeholder,
        name,
        type,
        select,
        options,
        disabled,
        enviado,
        configuracionCampos,
        obligatory,
        onchangePrefijo,
        valuePrefijo,
        viewPrefijo = true,
        help="",
        onChangeDate,
        handleDateChangeTime,
        onChangeValor,
        entity,
        bordeAzul,
        labelCenter,
        flex = "1 0 250px",
        disabledIcon = false
    } = props;

    let ancho = ["checkbox", "radio", "textarea"].filter(item => item === type)[0];


    return (
        <Campo
            error={error !== undefined && error !== ""}
            enviado={enviado}
            className={` ${className ? className : "p-2"}`}
            type={type}
            bordeAzul={bordeAzul}
            labelCenter={labelCenter}
            flex={ancho ? "1 0 100%" : flex}
        >

            {(label || error) &&
            <div>
                {help !== "" ?
                    <Tooltip
                        title={help}
                        trigger={"mouseenter"}
                        position={"top"}
                    >
                        <label>
                            {error ? error : (label ? label : "")} {obligatory && !error && <span>*</span>}
                            <i className={`fa fa-info-circle`}/>
                        </label>
                    </Tooltip>
                    :
                    <label>
                        {error ? error : (label ? label : "")} {obligatory && !error && <span>*</span>}
                    </label>}
            </div>
            }

            {type === "password" &&
            <input
                style={{
                    boxShadow: "0 1px 3px rgba(0,0,0,.2)"
                }}
                type="password"
                placeholder={placeholder}
                value={value}
                onChange={onchange}
                name={name || name == "0" ? name : ""}
                id={id ? id : ""}
                disabled={disabled}
                maxLength={maxLength(configuracionCampos, type)}
            />
            }

            {type === "text" &&
            <input
                style={{
                    boxShadow: "0 1px 3px rgba(0,0,0,.2)"
                }}
                type="text"
                placeholder={placeholder}
                value={value}
                onChange={onchange}
                name={name || name == "0" ? name : ""}
                id={id ? id : ""}
                disabled={disabled}
                maxLength={maxLength(configuracionCampos, type)}
            />
            }
            {disabledIcon &&
                <AntdIcon
                    style={styleErrorIcon} 
                    type={StopOutline}/>}
            {type === "number" || type === "tel" &&
            <input
                style={{
                    boxShadow: "0 1px 3px rgba(0,0,0,.2)"
                }}
                type="number"
                placeholder={placeholder}
                value={value}
                onChange={e=>{
                    let val = e.target.value.replace(/[^0-9]/g,'')
                    let obj = {target:{value:val,name}};
                    onchange(obj)
                }}
                name={name || name == "0" ? name : ""}
                id={id ? id : ""}
                disabled={disabled}
                maxLength={maxLength(configuracionCampos, type)}
                className={disabled && "disabled-prd"}
            />
            }

            {type === "iva" &&
            <input
                style={{
                    boxShadow: "0 1px 3px rgba(0,0,0,.2)"
                }}
                type="number"
                placeholder={placeholder}
                value={value}
                onChange={onchange}
                name={name || name == "0" ? name : ""}
                id={id ? id : ""}
                disabled={disabled}
                maxLength={3}
            />
            }

            {
                type === "mount" &&
                (

                    <Cleave
                        type={"tel"}
                        value={value}
                        options={{
                            numeral: true,
                            numeralDecimalMark: '.',
                            delimiter: ',',
                            prefix: '$',
                            signBeforePrefix: true,
                            rawValueTrimPrefix: true
                        }}
                        disabled={disabled}
                        onChange={e => {
                            // let val = parseFloat(parseFloat(e.target.rawValue).toFixed(2))
                            onChangeValor(e.target.rawValue?e.target.rawValue:0,name)
                        }}
                    />
                )
            }

            {select &&
            <select
                name={name || name == "0" ? name : ""}
                id={id ? id : ""}
                value={value}
                onChange={onchange}
                disabled={disabled}
            >
                <option value="" disabled>Seleccione...</option>
                {options.map(item => <option value={item.value} key={item.value}>{item.name}</option>)}
            </select>
            }
            {
                type === "date" &&
                (
                    <ThemeProvider theme={materialTheme}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                            <KeyboardDatePicker
                                autoOk
                                variant="inline"
                                placeholder={placeholder}
                                inputVariant="outlined"
                                label=""
                                format="yyyy/MM/dd"
                                value={value === "" ? null : new Date(value)}
                                InputAdornmentProps={{position: "end"}}
                                onChange={date => onChangeDate(date)}
                                invalidDateMessage={"Fecha invalida"}
                                disabled={disabled}
                                // onAccept={date=>console.log(date)}
                            />
                        </MuiPickersUtilsProvider>
                    </ThemeProvider>
                )
            }


            {
                type === "time" &&
                <ThemeProvider theme={materialTheme}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                        <KeyboardTimePicker
                            autoOk
                            label=""
                            placeholder={placeholder}
                            variant="inline"
                            inputVariant="outlined"
                            mask="__:__ _M"
                            value={value === "" ? null : new Date(value)}
                            onChange={handleDateChangeTime}
                            keyboardIcon={<i className="fas fa-clock fa-sm"> </i>}
                            invalidDateMessage={"Hora invalida"}
                        />
                    </MuiPickersUtilsProvider>
                </ThemeProvider>
            }

            {
                type === "radio" &&
                options.map((item, key) => {
                    return (
                        <div key={`radio-${key}`} className="custom-control custom-radio custom-control-inline">
                            <input
                                type="radio"
                                id={item.value}
                                value={item.value}
                                onChange={onchange}
                                checked={value === item.value}
                                name={name || name == "0" ? name : ""}
                                className="custom-control-input"
                            />
                            <label style={{color: "#525F7F", paddingTop: 3}} className="custom-control-label"
                                   htmlFor={item.value}>{item.name}</label>
                        </div>
                    )
                })
            }

            {
                type === "checkbox" && (
                    options.map((item, key) => {
                        return (
                            <div key={`checkbox-${key}`}
                                 className="custom-control custom-checkbox custom-control-inline">
                                <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id={`customCheck${entity}-${name + key + 1}`}
                                    checked={checkedCheckbox(value, item.value)}
                                    name={name || name == "0" ? name : ""}
                                    value={item.value}
                                    onChange={onchange}
                                />
                                <label
                                    style={{color: "#525F7F", paddingTop: 3}}
                                    className="custom-control-label" htmlFor={`customCheck${entity}-${name + key + 1}`}>
                                    {item.name}</label>
                            </div>
                        )
                    })
                )
            }

            {type === "textarea" &&
            <textarea
                style={{
                    boxShadow: "rgba(0,0,0,.2) 0 1px 3px ",
                    borderRadius: 4
                }}
                style={{width: "100%"}}
                type={"textarea"}
                placeholder={placeholder}
                value={value}
                onChange={onchange}
                name={name || name == "0" ? name : ""}
                id={id ? id : ""}
                disabled={disabled}
                rows={3}
                maxLength={maxLength(configuracionCampos, type)}
            />
            }

            {
                type === "telephone" &&
                <div
                    className="campoTelefono f01"
                >

                    {
                        viewPrefijo ?
                            <div className="borde f01 ">
                                <Flex elastic={"0 0 125px "} className={"px-2"}>
                                    <ReactSelectFlag
                                        onChange={(e)=> onchangePrefijo({target:{name:name, value:e}})}
                                        value={valuePrefijo}
                                        id_pais={"CO"}
                                    />
                                </Flex>
                                <Flex elastic={"1 0 50%"} >
                                    <input
                                        type="number"
                                        placeholder={placeholder}
                                        name={name || name == "0" ? name : ""}
                                        value={value}
                                        id={"telephone"}
                                        onChange={onchange}
                                        autoComplete="off"
                                        className={"pl-0"}
                                    />
                                </Flex>
                            </div> :
                            <div className="borde f01">
                                <input
                                    type="number"
                                    placeholder={placeholder}
                                    name={name || name == "0" ? name : ""}
                                    value={value}
                                    id={"telephone"}
                                    onChange={onchange}
                                    autoComplete="off"
                                />
                            </div>

                    }


                </div>
            }

            { type === "email" &&
                <input
                    style={{boxShadow: "0 1px 3px rgba(0,0,0,.2)"}}
                    type="text"
                    placeholder={placeholder}
                    value={value}
                    onChange={e=> onchange(e)}
                    name={name || name == "0" ? name : ""}
                    id={id ? id : ""}
                    disabled={disabled}
                    maxLength={maxLength(configuracionCampos, type)}
                />
            }

            {enviado !== "" &&
            <div className="col-12 px-0 enviado">
                <small>{enviado}</small>
            </div>}
        </Campo>
    )
};

export default MyCampo;
